import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import { withStyles } from "@material-ui/core/styles";
import ChartistGraph from "react-chartist";

//Dummy Data
/*

  DEV

*/
import { dailySalesChart, emailsSubscriptionChart, completedTasksChart } from "./variables/charts";
import { app, client, devices } from "./variables/general";

//MUI
import Grid from "@material-ui/core/Grid";

//Custom
import Card from "./components/Card/Card.jsx";
import CardHeader from "./components/Card/CardHeader.jsx";
import CardIcon from "./components/Card/CardIcon.jsx";
import CardBody from "./components/Card/CardBody.jsx";
import CardFooter from "./components/Card/CardFooter.jsx";
import CustomTabs from "./components/CustomTabs/CustomTabs.jsx";
import GridItem from "./components/Grid/GridItem.jsx";
import Table from "./components/Table/Table.jsx";
import Tasks from "./components/Tasks/Tasks.jsx";

//Icons
import Accessibility from "@material-ui/icons/Accessibility";
import AccessTime from "@material-ui/icons/AccessTime";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import BugReport from "@material-ui/icons/BugReport";
import Cloud from "@material-ui/icons/Cloud";
import Code from "@material-ui/icons/Code";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";

//Hero Icons

import FlashOff from "@material-ui/icons/FlashOff";
import WbSunny from "@material-ui/icons/WbSunny";

// import dashboardStyle from "./components/assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

//Redux
function mapStateToProps(state) {
  return {
    weatherTemp: state.data.weather.data.main.temp,
    weatherTempMax: state.data.weather.data.main.temp_max,
    weatherTempMin: state.data.weather.data.main.temp_min,
    weatherDescription: state.data.weather.data.weather[0].description
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

const theme = {
  root: {
    color: "black"
  },
  cardCategory: {
    color: "rgba(0,0,0,.8)"
  },
  cardHeader: {
    color: "black"
  },
  cardTitle: {
    color: "black"
  }
};

class Overview extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes, weatherTemp, weatherTempMax, weatherTempMin, weatherDescription } = this.props;

    return (
      <div className={classes.root}>
        <Grid container>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="warning" stats icon>
                <CardIcon color="warning">
                  <WbSunny />
                </CardIcon>
                <p className={classes.cardCategory}>{String(weatherDescription).toUpperCase()}</p>
                <h3 className={classes.cardTitle}>
                  {weatherTemp} <small>℉</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  HIGH: {weatherTempMax}, LOW: {weatherTempMin}
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="success" stats icon>
                <CardIcon color="success">
                  <FlashOff />
                </CardIcon>
                <p className={classes.cardCategory}>ELECTRIC DRAW</p>
                <h3 className={classes.cardTitle}>
                  8.5 <small>MW</small>
                </h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <DateRange />
                  rated hourly
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="danger" stats icon>
                <CardIcon color="danger">
                  <div />
                </CardIcon>
                <p className={classes.cardCategory}>PENDING ISSUES</p>
                <h3 className={classes.cardTitle}>10</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <LocalOffer />
                  check devices
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="info">
                  <Accessibility />
                </CardIcon>
                <p className={classes.cardCategory}>OCCUPANCY</p>
                <h3 className={classes.cardTitle}>+245</h3>
              </CardHeader>
              <CardFooter stats>
                <div className={classes.stats}>
                  <Update />
                  estimates updated hourly
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </Grid>
        <Grid container>
          <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="success">
                <ChartistGraph
                  className="ct-chart"
                  data={dailySalesChart.data}
                  type="Line"
                  options={dailySalesChart.options}
                  listener={dailySalesChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>weekly energy output</h4>
                <p className={classes.cardCategory}>
                  <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 7%
                  </span>{" "}
                  increase in energy usage.
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> updated 4 minutes ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="warning">
                <ChartistGraph
                  className="ct-chart"
                  data={emailsSubscriptionChart.data}
                  type="Bar"
                  options={emailsSubscriptionChart.options}
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>monthly energy output</h4>
                <p className={classes.cardCategory}>view additional analytics</p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> updates on the first
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card chart>
              <CardHeader color="danger">
                <ChartistGraph
                  className="ct-chart"
                  data={completedTasksChart.data}
                  type="Line"
                  options={completedTasksChart.options}
                  listener={completedTasksChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>Completed Tasks</h4>
                <p className={classes.cardCategory}>Last Campaign Performance</p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> campaign sent 2 days ago
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </Grid>
        <Grid container>
          <GridItem xs={12} sm={12} md={6}>
            <CustomTabs
              title="Tasks:"
              headerColor="primary"
              tabs={[
                {
                  tabName: "devices",
                  tabIcon: BugReport,
                  tabContent: (
                    <Tasks checkedIndexes={[]} tasksIndexes={[0, 1, 2, 3]} tasks={devices} />
                  )
                },
                {
                  tabName: "app",
                  tabIcon: Code,
                  tabContent: <Tasks checkedIndexes={[]} tasksIndexes={[0, 1, 2, 3]} tasks={app} />
                },
                {
                  tabName: "client",
                  tabIcon: Cloud,
                  tabContent: (
                    <Tasks checkedIndexes={[]} tasksIndexes={[0, 1, 2, 3]} tasks={client} />
                  )
                }
              ]}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="warning">
                <h4 className={classes.cardTitleWhite}>USERS</h4>
                <p className={classes.cardCategoryWhite}>employees currently logged in</p>
              </CardHeader>
              <CardBody>
                <Table
                  tableHeaderColor="warning"
                  tableHead={["id", "position", "name", "email", "phone"]}
                  tableData={[
                    ["1", "engineer", "Titan One", "titan@saturn.sol", "419 492 5125"],
                    ["2", "manager", "Hyperion One", "hyperion@saturn.sol", "523 162 5279"],
                    ["3", "engineer", "Enceladus One", "enceladus@saturn.sol", "253 276 1560"]
                  ]}
                />
              </CardBody>
            </Card>
          </GridItem>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(theme)(Overview));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/dashboard_tabs/Overview.js